import React, { createContext, useState, useContext } from "react";

const ResultContext = createContext();

const ResultProvider = ({ children }) => {
  const [result, setResult] = useState();

  if (result) {
    localStorage.setItem("@Claro-Catalogo:result", JSON.stringify(result));
  }

  return (
    <ResultContext.Provider value={{ result, setResult }}>
      {children}
    </ResultContext.Provider>
  );
};

function useResult() {
  const context = useContext(ResultContext);

  return context;
}

export { ResultProvider, useResult };
